import { useState, useRef } from 'react';
import { HiOutlineChevronUp, HiOutlineChevronDown } from 'react-icons/hi';
import Monitoring from '../images/Monitoring.svg';
import SecurityServices from '../images/SecurityServices.svg';
import TechnicalSupport from '../images/TechnicalSupport.svg';

const ManagedServices = () => {

//Dropdown content of How we help section
const [isOpen, setIsOpen] = useState(false);

const toggleSection = (section) => {
setIsOpen((prev) => ({
    ...prev,
    [section]: !prev[section],
}));
};
const contentRef = useRef(null);

    return (
        <>
            <div className='bg-white py-12 lg:py-16 xl:py-24 flex flex-col items-center'>
                <div className='flex flex-col items-center mb-8'>
                    <h1 className='text--[var(--kaizekblue)] font-uiBold text-center text-4xl xl:text-5xl'>Managed Services</h1>
                    <p className='text-[var(--lightgray)] font-symbol text-xl lg:text-2xl text-center mx-4 my-4'>Comprehensive support and maintenance solutions</p>
                </div>

                <div className='pt-8 lg:pt-16 xl:w-8/12 mx-4 sm:mx-10 lg:mx-12 grid grid-flow-row gap-4 lg:gap-8'>
                    {/* 0.625 10px border */}
                    <div className="rounded-xl p-3 sm:p-6 border-l-[0.625rem] bg-[var(--violetwhite)] border-[#878DC1] shadow-lg cursor-pointer"
                        onClick={() => toggleSection('monitoring')}
                        aria-expanded={isOpen['monitoring']}
                        aria-controls="monitoring-content"
                        role="button"
                        aria-label="Toggle 24/7 Monitoring Section">
                        <div className='flex-row flex justify-between'>
                            <div className='flex flex-row items-center'>
                                <img src={Monitoring} alt="24/7 Monitoring"></img>
                                <h2 className="font-uiSemilight text-xl sm:text-2xl xl:text-[1.75rem] text-[var(--darkgray)] px-6 xl:px-8">24/7 Monitoring</h2>
                            </div>
                            <div className="items-center flex">
                            <span>{isOpen['monitoring'] ? <HiOutlineChevronUp className='text-[var(--kaizekblue)]' size={20} style={{ strokeWidth: 3 }} /> : <HiOutlineChevronDown className='text-[var(--kaizekblue)]' size={20} style={{ strokeWidth: 3 }} />}</span>
                            </div>
                        </div>
                        <div id="monitoring-content" ref={contentRef}
                            style={{
                                maxHeight: isOpen['monitoring']
                                ? `${contentRef.current?.scrollHeight}px`
                                : "0px",
                            }}
                            className={`transition-max-height duration-500 ease-in-out overflow-hidden px-2 lg:px-4 ${
                                            isOpen["monitoring"] ? "max-h-screen" : "max-h-0"}`}>
                            <h2 className='text-[var(--lightgray)] font-symbol ps-3 text-base my-6'>
                            We provide continuous system monitoring to ensure seamless operations. Our real-time tracking keeps you updated on system performance. Automated alerts notify you instantly of any issues. Comprehensive performance tracking helps optimize efficiency. Advanced issue detection identifies problems before they escalate.
                            </h2>
                        </div>
                    </div>

                    <div className="rounded-xl p-3 sm:p-6 border-l-[0.625rem] bg-[var(--violetwhite)] border-[#878DC1] shadow-lg cursor-pointer"
                        onClick={() => toggleSection('securityServices')}
                        aria-expanded={isOpen['securityServices']}
                        aria-controls="securityServices-content"
                        role="button"
                        aria-label="Toggle Security Services Section">
                        <div className='flex-row flex justify-between'>
                            <div className='flex flex-row items-center'>
                                <img src={SecurityServices} alt="Security Services"></img>
                                <h2 className="font-uiSemilight text-xl sm:text-2xl xl:text-[1.75rem] text-[var(--darkgray)] px-6 xl:px-8">Security Services</h2>
                            </div>
                            <div className="items-center flex">
                            <span>{isOpen['securityServices'] ? <HiOutlineChevronUp className='text-[var(--kaizekblue)]' size={20} style={{ strokeWidth: 3 }} /> : <HiOutlineChevronDown className='text-[var(--kaizekblue)]' size={20} style={{ strokeWidth: 3 }} />}</span>
                            </div>
                        </div>
                        <div id="securityServices-content" ref={contentRef}
                            style={{
                                maxHeight: isOpen['securityServices']
                                ? `${contentRef.current?.scrollHeight}px`
                                : "0px",
                            }}
                            className={`transition-max-height duration-500 ease-in-out overflow-hidden px-2 lg:px-4 ${
                                            isOpen["securityServices"] ? "max-h-screen" : "max-h-0"}`}>
                            <h2 className='text-[var(--lightgray)] font-symbol ps-3 text-base my-6'>
                            We deliver ongoing security management to keep your systems protected. Regular security updates ensure your defenses stay up to date. Vulnerability scanning identifies potential risks before they become threats. Advanced threat detection monitors for suspicious activity in real time. Efficient incident response minimizes damage and ensures quick recovery.
                            </h2>
                        </div>
                    </div>

                    <div className="rounded-xl p-3 sm:p-6 border-l-[0.625rem] bg-[var(--violetwhite)] border-[#878DC1] shadow-lg cursor-pointer"
                        onClick={() => toggleSection('technicalSupport')}
                        aria-expanded={isOpen['technicalSupport']}
                        aria-controls="technicalSupport-content"
                        role="button"
                        aria-label="Toggle Technical Support Section">
                        <div className='flex-row flex justify-between'>
                            <div className='flex flex-row items-center'>
                                <img src={TechnicalSupport} alt="Technical Support"></img>
                                <h2 className="font-uiSemilight text-xl sm:text-2xl xl:text-[1.75rem] text-[var(--darkgray)] px-6 xl:px-8">Technical Support</h2>
                            </div>
                            <div className="items-center flex">
                            <span>{isOpen['technicalSupport'] ? <HiOutlineChevronUp className='text-[var(--kaizekblue)]' size={20} style={{ strokeWidth: 3 }} /> : <HiOutlineChevronDown className='text-[var(--kaizekblue)]' size={20} style={{ strokeWidth: 3 }} />}</span>
                            </div>
                        </div>
                        <div id="technicalSupport-content" ref={contentRef}
                            style={{
                                maxHeight: isOpen['technicalSupport']
                                ? `${contentRef.current?.scrollHeight}px`
                                : "0px",
                            }}
                            className={`transition-max-height duration-500 ease-in-out overflow-hidden px-2 lg:px-4 ${
                                            isOpen["technicalSupport"] ? "max-h-screen" : "max-h-0"}`}>
                            <h2 className='text-[var(--lightgray)] font-symbol ps-3 text-base my-6'>
                            We offer expert technical assistance to keep your systems running smoothly. Our 24/7 support ensures help is always available when you need it. Regular maintenance updates keep your technology up to date and secure. Performance optimization enhances efficiency and reliability. Comprehensive documentation provides clear guidance for seamless operations.
                            </h2>
                        </div>
                    </div>
                    {/* Dropdown section ends */}
                </div>
            </div>
        </>
    )
}

export default ManagedServices